import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/IQAC-MeetingMinutes.css';

const meetingData = [
  { year: '2014–15', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2015–16', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2016–17', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2017–18', meetings: ['Meeting No.1', 'Meeting No. 2'] },
  { year: '2018–19', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2019–20', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2020–21', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2022–23', meetings: ['Meeting No. 1', 'Meeting No. 2'] },
  { year: '2024–25', meetings: ['Meeting No. 1'] },
];

const IQACMinutes = () => {
  const [fade, setFade] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setFade(true), 100);
  }, []);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`minutes-container ${fade ? 'fade-in' : ''}`}>
        <section className="minutes-header">
          <h4>Shri Mulikadevi Mahavidyalaya, Nighoj</h4>
          <h2>IQAC Meeting Minutes</h2>
          <p>
            Review the record of IQAC meetings conducted each academic year, detailing discussions, decisions, and quality measures undertaken.
          </p>
        </section>

        <section className="minutes-list">
          {meetingData.map((yearData, idx) => (
            <div key={idx} className="year-group animate-card">
              <h3>{yearData.year}</h3>
              <ul>
                {yearData.meetings.map((mtg, i2) => (
                  <li key={i2}>
                    <a href={`/pdfs/iqac/${yearData.year}-${mtg}.pdf`} target="_blank" rel="noopener noreferrer">
                      {mtg}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      </div>
      </section>
      <Footer />
    </>
  );
};

export default IQACMinutes;
